import { render, staticRenderFns } from "./productModify.vue?vue&type=template&id=5fb9552a&scoped=true&"
import script from "./productModify.vue?vue&type=script&lang=js&"
export * from "./productModify.vue?vue&type=script&lang=js&"
import style0 from "./productModify.vue?vue&type=style&index=0&id=5fb9552a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb9552a",
  null
  
)

export default component.exports